import {EventBus} from '@/event-bus.js';
import {getField, updateField} from 'vuex-map-fields';
import {buildHeaders} from '@/api/_manager';
import DEFINES from '@/defines';
const PUSHER_APP_KEY = process.env.VUE_APP_PUSHER_APP_KEY;
const PUSHER_APP_CLUSTER = process.env.VUE_APP_PUSHER_APP_CLUSTER;
import * as API from '@/api';

function initialState () {
  return {
    profile: null,
    previous_profile: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async get (context, payload) {
    var response = await API.user.get (payload);
    context.commit ('set_profile', {
      user: response.user,
    });
    return response;
  },
  async update (context, payload) {
    var response = await API.user.update (payload);
    context.commit ('set_profile', {
      user: response.user,
    });
    return response;
  },

  async setGapiToken (context, payload) {
    var response = await API.user.setGapiToken (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getUser (state, getters, rootState) {
    return state.profile;
  },
  getPreviousProfile (state) {
    return state.previous_profile;
  },
  isSuperAdmin: state => state.profile.role == 50,
  isAdmin: state => state.profile.role > 20,
};

// mutations
const mutations = {
  updateField,
  set_profile (state, payload) {
    state.profile = payload.user;
  },
  set_previous_profile (state, payload) {
    state.previous_profile = payload;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
